import ScreenNotificationTypeUpdate from 'screens/NotificationType/Update';
import ScreenNotificationTypeCreate from 'screens/NotificationType/Create';
import ScreenNotificationTypeList from 'screens/NotificationType/List';
import { NOTIFICATION_TYPE } from 'routes/paths';

const notificationTypeRoutes = [
  {
    path: NOTIFICATION_TYPE.UPDATE,
    name: 'NotificationTypeUpdate',
    component: ScreenNotificationTypeUpdate,
    allowPermissions: ['change_notificationtype'],
  },
  {
    path: NOTIFICATION_TYPE.CREATE,
    name: 'NotificationTypeCreate',
    component: ScreenNotificationTypeCreate,
    allowPermissions: ['add_notificationtype'],
  },
  {
    path: NOTIFICATION_TYPE.LIST,
    name: 'NotificationTypeList',
    component: ScreenNotificationTypeList,
    loginRequired: true,
    allowPermissions: ['list_notificationtype'],
  },
];

export default notificationTypeRoutes;
